let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6CmcM")).then(() => parcelRequire('318wD'));